
import React from 'react';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';

const SelectAttribute = ({
    attributes,
    label,
    onChange,
    placeholder,
    readOnly,
    value
}) => {

    const getOptions = () => {
        return attributes.map(item => {
            return {
                key: item.id,
                text: item.title
            };
        });
    }

    const handleChange = (evt, option, index, value) => {
        if (onChange) {
            onChange(option.key);
        }
    }

    return (
        <ComboBox
            label={label || 'Atribut'}
            placeholder={placeholder || 'Vyberte atribut'}
            disabled={readOnly}
            selectedKey={value}
            options={getOptions()}
            onChange={handleChange}
        />
    );
}

export default SelectAttribute;
